import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (p9306)
// ============================================================

export interface QueryParams {
  deptFrom?: string;
  deptTo?: string;
}

export interface StaffingRow {
  dept_code: string;
  dept_name: string;
  title_code: string;
  title_name: string;
  planned_count: number;
  actual_count: number;
  emp_no?: string;
  emp_name?: string;
  hire_date?: string;
  dept_planned: number;
  dept_approved: number;
}

export interface DeptSummary {
  dept_code: string;
  dept_name: string;
  dept_planned: number;
  dept_approved: number;
  total_planned: number;
  total_actual: number;
}

export interface CompanyTotals {
  total_depts: number;
  total_planned: number;
  total_approved: number;
  total_actual: number;
}

export interface QueryResult {
  data: StaffingRow[];
  summary: DeptSummary[];
  totals: CompanyTotals;
  message?: string;
}

// ============================================================
// API Client
// ============================================================

export const p9306Api = {
  async query(params: QueryParams): Promise<QueryResult> {
    const res = await apiClient.post('/api/p9306/query', params);
    return res.data;
  },

  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(
        `/api/p9306/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`
      );
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
